import { Route, Routes, useLocation, Navigate } from 'react-router-dom';

import Main from './pages/Main/Main';
import Header from './components/layout/Header';

import ProductsPage from './pages/ProductsPage/ProductsPage';
import Detail from './pages/ProductsPage/Detail/Detail';

import Board from './pages/Board/Board';
import Post from './pages/Board/Post';
import PostForm from './pages/Board/PostForm';

import Order from './pages/Order/Order';
import OrderSuccess from './pages/Order/OrderSuccess';

import MyPage from './pages/MyPage/MyPage';
import OrderList from './pages/MyPage/OrderList';
import OrderDetail from './pages/MyPage/OrderDetail';
import MyInfo from './pages/MyPage/MyInfo';

import PopupContainer from './components/layout/PopupContainer';
import FindId from './pages/Sign/FindId';
import FindIdResult from './pages/Sign/FindIdResult';
import FindPW from './pages/Sign/FindPw';
import FindPwResult from './pages/Sign/FindPwResult';

import Login from './pages/Sign/Login';
import Signup from './pages/Sign/SignUp';
import Cart from './pages/Cart/Cart';
import DeliveryAddress from './pages/MyPage/DeliveryAddress';



function App() {
    const location = useLocation();
    const isPopUp = location.pathname.includes('popUp');

    return (
        <div className="App">
            {
                !isPopUp ? <Header /> : null
            }
            <Routes>
                <Route path="/" element={<Main />} />
                {/* Products */}
                <Route path="/products">
                    <Route path=":category" element={<ProductsPage />} />
                    <Route path="detail/:productCode" element={<Detail />} />
                </Route>
                {/* Board */}
                <Route path="/board">
                    <Route index element={<Board />} />
                    <Route path="form" element={<PostForm />} />
                    <Route path=":postId" element={<Post />} />
                    <Route path=":postId/edit" element={<PostForm />} />
                </Route>
                {/* Order */}
                <Route path="/order">
                    <Route index element={<Order />} />
                    <Route path="success" element={<OrderSuccess />} />
                </Route>
                {/* My */}
                <Route path="/my" element={<MyPage />}>
                    <Route index element={ <Navigate to="orders" replace /> } />
                    <Route path="orders" element={ <OrderList /> } />
                    <Route path="orders/:orderNumber" element={ <OrderDetail /> } />
                    <Route path="info" element={ <MyInfo /> } />
                </Route>

                {/* PopUp */}
                <Route path="/popUp" element={ <PopupContainer /> }>
                    <Route path="find-id">
                        <Route index element={ <FindId /> } />
                        <Route path="result" element={ <FindIdResult /> } />
                    </Route>
                    <Route path="find-pw">
                        <Route index element={ <FindPW /> } />
                        <Route path="result" element={ <FindPwResult /> } />
                    </Route>
                    <Route path=":orderNumber/delivery-address" element={ <DeliveryAddress /> } />
                </Route>
                {/* Others */}
                <Route path="/log-in" element={<Login />} />
                <Route path="/sign-up" element={ <Signup /> } />
                <Route path="/shopping-cart" element={<Cart />} />

            </Routes>
        </div>
    );
}

export default App;